
import { RespBase } from './ItemBase.js';


export class ReqLogin {
    constructor({ account, password, texIdNumber = "" }) {
        this.account = account
        this.password = password
        this.texIdNumber = texIdNumber
    }
}

/**
 * 
 */
export class RespLogin extends RespBase {
    constructor({ status, token, userInfo }) {
        super(status)
        this.token = token
        this.userInfo = userInfo
    }
}

export class UserInfo {
    constructor({ accountId, mobile, email, nickName, avatar, creatAt, companyId, companyName, departmentId, departmentName }) {
        this.accountId = accountId
        this.mobile = mobile
        this.email = email
        this.nickName = nickName
        this.avatar = avatar
        this.creatAt = creatAt
        this.companyId = companyId
        this.companyName = companyName
        this.departmentId = departmentId
        this.departmentName = departmentName
    }
    fromJson(jsonDate) {
        this.accountId = jsonDate.accountId
        this.mobile = jsonDate.mobile
        this.email = jsonDate.email
        this.nickName = jsonDate.nickName
        this.avatar = jsonDate.avatar
        this.creatAt = jsonDate.creatAt
        this.companyId = jsonDate.companyId
        this.companyName = jsonDate.companyName
        this.departmentId = jsonDate.departmentId
        this.departmentName = jsonDate.departmentName
        this.isDisable = jsonDate.isDisable
        this.companyIsDisable = jsonDate.companyIsDisable
    }
}

export class UserRegister extends UserInfo {
    constructor({ password, mobile, email, nickName, avatar, roleId, creatAt }) {
        super({ mobile, email, nickName, avatar })
        this.password = password
        this.roleId = roleId
        this.creatAt = creatAt
        this.isDisable = false
    }
}

export class LoginToken {
    constructor({ accountId, token }) {
        this.accountId = accountId
        this.token = token
    }
}

/**
 * 申請人列表
 */
export class ReqClientAdminListPage {
    constructor({ start, limit }) {
        this.start = start
        this.limit = limit
    }
}


/**
 * 申請人檢視
 */
export class RespClientAdminDetail {
    /*
    constructor({accountId, mobile, email, nickName, avatar, creatAt, isDisabled, enableDate, disableDate, 
        companyCount, companyEnableCount, companyDisableCount}) {
        this.accountId = accountId
        this.mobile = mobile
        this.email = email
        this.nickName = nickName
        this.avatar = avatar
        this.creatAt = creatAt
        this.isDisabled = isDisabled
        this.enableDate = enableDate
        this.disableDate = disableDate
        this.companyCount = companyCount
        this.companyEnableCount = companyEnableCount
        this.companyDisableCount = companyDisableCount
    }
*/
    fromJson(jsonDate) {
        if (jsonDate === undefined)
            return
        this.accountId = jsonDate.accountId
        this.mobile = jsonDate.mobile
        this.email = jsonDate.email
        this.nickName = jsonDate.nickName
        this.avatar = jsonDate.avatar
        this.creatAt = jsonDate.creatAt
        this.isDisable = jsonDate.isDisable
        this.note = jsonDate.note
        this.enableDate = jsonDate.enableDate
        this.disableDate = jsonDate.disableDate
        this.companyCount = jsonDate.companyCount
        this.companyEnableCount = jsonDate.companyEnableCount
        this.companyDisableCount = jsonDate.companyDisableCount
    }
}

/**
 * 申請人新增
 */
export class ReqClientAdminAdd {
    constructor({ mobile, email, nickName, isDisable }) {
        this.mobile = mobile
        this.email = email
        this.nickName = nickName
        if (isDisable !== undefined)
            this.isDisable = isDisable
    }

    fromJson(jsonDate) {
        this.mobile = jsonDate.mobile
        this.email = jsonDate.email
        this.nickName = jsonDate.nickName
        this.isDisable = jsonDate.isDisable
    }
}

/**
 * 申請人編輯
 */
export class ReqClientAdminEdit {
    constructor({ accountId, email, nickName, isDisable }) {
        this.accountId = accountId
        this.email = email
        this.nickName = nickName
        if (isDisable !== undefined)
            this.isDisable = isDisable
    }

    fromJson(jsonDate) {
        this.accountId = jsonDate.accountId
        this.email = jsonDate.email
        this.nickName = jsonDate.nickName
        this.isDisable = jsonDate.isDisable
    }
}

export class ReqSystemAccountList {
    constructor({ start, limit, mobile, nickName, isDisable }) {
        this.start = start
        this.limit = limit
        this.mobile = mobile
        this.nickName = nickName
        this.isDisable = isDisable === -1 ? undefined : isDisable
    }
}


export class ReqCheckSystemAccount {
    constructor({ mobile }) {
        this.mobile = mobile
    }

    fromJson(jsonDate) {
        this.mobile = jsonDate.mobile
    }
}

export class ReqAddSystemAccount {
    constructor({ mobile, nickName, note, isDisable, creatAccountId, creatAt }) {
        this.mobile = mobile
        this.email = ""
        this.nickName = nickName
        this.avatar = ""
        this.note = note
        this.isDisable = isDisable
        this.creatAccountId = creatAccountId
        this.creatAt = creatAt
    }
    fromJson(jsonDate) {
        this.mobile = jsonDate.mobile
        this.email = jsonDate.email
        this.nickName = jsonDate.nickName
        this.avatar = jsonDate.avatar
        this.note = jsonDate.note
        this.isDisable = jsonDate.isDisable
        this.creatAccountId = jsonDate.creatAccountId
        this.creatAt = jsonDate.creatAt
    }
}

export class ReqUpdateSystemAccount {
    constructor({ accountId, mobile, nickName, note, isDisable, addAccountRoles, cutAccountRoles }) {
        this.accountId = accountId
        this.mobile = mobile
        this.email = ""
        this.nickName = nickName
        this.avatar = ""
        this.note = note
        this.isDisable = isDisable
        this.addAccountRoles = addAccountRoles
        this.cutAccountRoles = cutAccountRoles
    }
    fromJson(jsonDate) {
        this.accountId = jsonDate.accountId
        this.mobile = jsonDate.mobile
        this.email = jsonDate.email
        this.nickName = jsonDate.nickName
        this.avatar = jsonDate.avatar
        this.note = jsonDate.note
        this.isDisable = jsonDate.isDisable
        this.addAccountRoles = jsonDate.addAccountRoles
        this.cutAccountRoles = jsonDate.cutAccountRoles
    }
}